"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fallback = (fallbackLanguage) => {
    return {
        name: 'fallback',
        lookup: (options) => {
            return fallbackLanguage;
        },
        cacheUserLanguage: () => {
        },
    };
};
exports.default = exports.fallback;
//# sourceMappingURL=fallback.js.map